"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = BarSettings;
exports.initialValues = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _style = _interopRequireDefault(require("../common/style.css"));
var _FieldGroup = _interopRequireDefault(require("../common/FieldGroup"));
var _LayoutField = _interopRequireDefault(require("../common/LayoutField"));
var _AxisFields = _interopRequireDefault(require("../common/AxisFields"));
var _ScaleFields = _interopRequireDefault(require("../common/ScaleFields"));
var _ThemeFields = _interopRequireDefault(require("../common/ThemeFields"));
var _MarkerFields = _interopRequireDefault(require("../common/MarkerFields"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialValues = {
  layout: 'vertical',
  enableLabel: true,
  minValue: 0,
  maxValue: 'auto',
  customColors: '#b3e2cd',
  groupMode: 'stacked',
  axisLeft: {
    legendPosition: 'middle',
    legendOffset: -50,
    format: function format(v) {
      if (typeof v === 'number' && v.toString().includes('.')) return '';
      return v;
    }
  },
  axisBottom: {
    legendPosition: 'middle',
    legendOffset: 50,
    tickRotation: 25,
    format: function format(v) {
      if (typeof v === 'number' && v.toString().includes('.')) return '';
      return v;
    }
  },
  margin: {
    left: 80,
    right: 150,
    top: 50,
    bottom: 80
  },
  markers: [{
    axis: 'y',
    value: '',
    lineStyle: {
      strokeDasharray: 10
    },
    legend: '',
    legendOrientation: 'horizontal',
    legendPosition: 'top-right'
  }]
};
exports.initialValues = initialValues;
function BarSettings(_ref) {
  var field = _ref.field,
    form = _ref.form,
    children = _ref.children;
  (0, _react.useEffect)(function () {
    form.setFieldValue("".concat(field.name), _objectSpread(_objectSpread({}, initialValues), field.value));
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].settings
  }, /*#__PURE__*/_react["default"].createElement(BarSettings.Chart, {
    field: field,
    form: form
  }), /*#__PURE__*/_react["default"].createElement(BarSettings.Scale, {
    field: field,
    form: form
  }), /*#__PURE__*/_react["default"].createElement(BarSettings.AxisLeft, {
    field: field,
    form: form
  }), /*#__PURE__*/_react["default"].createElement(BarSettings.AxisBottom, {
    field: field,
    form: form
  }), /*#__PURE__*/_react["default"].createElement(BarSettings.Marker, {
    field: field,
    form: form
  }), /*#__PURE__*/_react["default"].createElement(BarSettings.Theme, {
    field: field,
    form: form
  }), children);
}
BarSettings.Chart = function (_ref2) {
  var field = _ref2.field,
    form = _ref2.form,
    children = _ref2.children;
  var _form$values = form.values,
    comparison = _form$values.comparison,
    visualizeAs = _form$values.visualizeAs;
  return /*#__PURE__*/_react["default"].createElement(_FieldGroup["default"], {
    label: "Chart"
  }, /*#__PURE__*/_react["default"].createElement(_LayoutField["default"], {
    field: field,
    form: form
  }), ['crosstab', 'timepoint', 'sideBySide', 'grouptype'].includes(comparison) && visualizeAs !== 'mean' && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Group Mode",
    name: "".concat(field.name, ".groupMode"),
    component: _cccisdFormik.CccisdSelect,
    options: [{
      value: 'grouped',
      label: 'Grouped'
    }, {
      value: 'stacked',
      label: 'Stacked'
    }]
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Show Numbers",
    name: "".concat(field.name, ".enableLabel"),
    component: _cccisdFormik.CccisdToggle
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Show Legend",
    name: "".concat(field.name, ".showLegend"),
    component: _cccisdFormik.CccisdToggle
  }), children);
};
BarSettings.Scale = function (_ref3) {
  var field = _ref3.field,
    form = _ref3.form,
    children = _ref3.children;
  return /*#__PURE__*/_react["default"].createElement(_FieldGroup["default"], {
    label: "Scale"
  }, /*#__PURE__*/_react["default"].createElement(_ScaleFields["default"], {
    field: field,
    form: form
  }), children);
};
BarSettings.AxisLeft = function (_ref4) {
  var field = _ref4.field,
    form = _ref4.form,
    children = _ref4.children;
  return /*#__PURE__*/_react["default"].createElement(_FieldGroup["default"], {
    label: "Vertical Axis"
  }, /*#__PURE__*/_react["default"].createElement(_AxisFields["default"], {
    field: field,
    form: form,
    axis: "left"
  }), children);
};
BarSettings.AxisBottom = function (_ref5) {
  var field = _ref5.field,
    form = _ref5.form,
    children = _ref5.children;
  return /*#__PURE__*/_react["default"].createElement(_FieldGroup["default"], {
    label: "Horizontal Axis"
  }, /*#__PURE__*/_react["default"].createElement(_AxisFields["default"], {
    field: field,
    form: form,
    axis: "bottom"
  }), children);
};
BarSettings.Marker = function (_ref6) {
  var field = _ref6.field,
    form = _ref6.form,
    children = _ref6.children;
  return /*#__PURE__*/_react["default"].createElement(_FieldGroup["default"], {
    label: "Marker"
  }, /*#__PURE__*/_react["default"].createElement(_MarkerFields["default"], {
    field: field,
    form: form
  }), children);
};
BarSettings.Theme = function (_ref7) {
  var field = _ref7.field,
    form = _ref7.form,
    children = _ref7.children;
  return /*#__PURE__*/_react["default"].createElement(_FieldGroup["default"], {
    label: "Theme"
  }, /*#__PURE__*/_react["default"].createElement(_ThemeFields["default"], {
    field: field,
    form: form,
    showCustomColor: false
  }), children);
};